import React from "react";
import SettingsNav from "../../../parts/settings-nav";

export const SettingsMenu = () => {
  return (
    <main role="settings-menu">
      <SettingsNav />
    </main>
  );
};
